import React, { useEffect, useState, useMemo } from 'react';
import {
  Row,
  Col,
  Affix,
  Image,
  Popover,
  List,
  Menu,
  Grid,
  Button,
  Drawer,
  Space,
} from 'antd';
import { useDispatch, useSelector } from 'react-redux';
// import { useHistory, useParams } from 'react-router';
import _ from 'lodash';
import { COLOR, FONT } from '../constants';
import useResponsive from '../hooks/useResponsive';
import { setDrawerVisible } from '../redux/actions/common';
import styled from 'styled-components'
import ScrollingText from './ScrollingText';
import TNContent from './TNContent';


const ScrollText = styled.div``

const TRANSPARENT_TIMELINE_HEIGHT = 400 * 10

const AppHeader = () => {
  const [transparentRate, setTransparentRate] = useState(0)

  const dispatch = useDispatch()

  const { isMobile } = useResponsive()


  useEffect(() => {
    const onScroll = e => {
      setTransparentRate(Math.min(e.target.documentElement.scrollTop / TRANSPARENT_TIMELINE_HEIGHT * 100, 100))
    };
    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (isMobile) {
    return (
      <Affix
        offsetTop={0}
        style={{
          zIndex: 10, position: 'absolute', width: '100%',
        }}
      >
        <Row justify='space-between' align='middle' style={{
          transition: 'all 0.5s',
          minHeight: 60, padding: '20px 5%',
          background: `rgba(255,240,210, ${Math.min(transparentRate, 0.97)})`,
          boxShadow: `0px 4px 5px rgba(243, 227, 195, ${Math.min(transparentRate, 0.4)})`
        }}>
          <Col span={10}>
            <a href="#landing">
              <img src="./company_logo.png" alt="company logo" style={{ width: '100%', objectFit: 'contain', height: '100%' }} />
            </a>
          </Col>
          <Col>
            <Button type='text' onClick={() => dispatch(setDrawerVisible(true))}>
              <img src="./assets/menu.svg" alt="" style={{ width: '100%', }} />
            </Button>
          </Col>
        </Row>
      </Affix>
    )
  }

  return (
    <Affix
      offsetTop={0}
      style={{
        zIndex: 10, position: 'absolute', width: '100%',
        // backgroundColor: `rgba(255,240,210, ${bg})`
      }}
    >
      <TNContent maxWidth={1920} color={`rgba(255,240,210, ${Math.min(transparentRate, 0.97)})`}>
        <Row justify='space-between' align='middle' style={{
          transition: 'all 0.5s',
          minHeight: transparentRate > 0.5 ? 65 : 80, padding: '0px 2%',
          // background: COLOR.primary
          background: `rgba(255,240,210, ${Math.min(transparentRate, 0.97)})`,
          boxShadow: `0px 4px 5px rgba(243, 227, 195, ${Math.min(transparentRate, 0.4)})`
        }}>
          <Col md={5} lg={5} xl={5}>
            <Row justify='center' align='middle'>
              <Col md={18} lg={16} xl={10}><a href="#landing"><img src="./company_logo.png" alt="company logo" style={{ width: '100%', }} /></a></Col>
            </Row>
          </Col>
          <Col md={12} lg={12} xl={10}>
            <Row justify='space-between' align='middle'>
              <Col style={FONT.button}>
                <a style={{ color: COLOR.menuText }} href="#collection-mint">
                  <ScrollingText text="Collection" />
                </a>
              </Col>
              <Col style={FONT.button}>
                <a style={{ color: COLOR.menuText }} href="#collection-info">
                  <ScrollingText text="About" />
                </a>
              </Col>
              <Col style={FONT.button}>
                <a style={{ color: COLOR.menuText }} href="#collection-faq">
                  <ScrollingText text="FAQ" />
                </a>
              </Col>
              <Col style={FONT.button}>
                <a style={{ color: COLOR.menuText }} href="#team-member">
                  <ScrollingText text="TEAM" />
                </a>
              </Col>
              <Col style={FONT.button}>
                <a style={{ color: COLOR.menuText }} href="#contact-us">
                  <ScrollingText text="CONTACT US" />
                </a>
              </Col>
            </Row>
          </Col>
          <Col md={5} lg={5} xl={5}>
            <Row justify='center'>
              <Col md={24} lg={20} xl={20}>
                <Row justify='space-between' align='middle'>
                  <Col>
                    <img src="./assets/slash.svg" alt="Slash" style={{ width: '100%' }} />
                  </Col>
                  <Col>
                    <a href="https://www.facebook.com/t9technine/" target="_blank" rel="noreferrer">
                      <img
                        onMouseLeave={(e) => {
                          e.target.src = './assets/facebook.svg'
                        }}
                        onMouseEnter={(e) => {
                          e.target.src = './assets/facebook_color.svg'
                        }}
                        src="./assets/facebook.svg" alt="Facebook" style={{ width: 20 }} />
                    </a>
                  </Col>
                  <Col>
                    <a href="https://www.linkedin.com/company/technine/" target="_blank" rel="noreferrer">
                      <img
                        onMouseLeave={(e) => {
                          e.target.src = './assets/linkedin.svg'
                        }}
                        onMouseEnter={(e) => {
                          e.target.src = './assets/linkedin_color.svg'
                        }}
                        src="./assets/linkedin.svg" alt="Linkedin" style={{ width: 20 }} />
                    </a>
                  </Col>
                  <Col>
                    <a href="https://www.visiongo.hsbc.com.hk/zh-HK/company/technine/" target="_blank" rel="noreferrer">
                      <img
                        onMouseLeave={(e) => {
                          e.target.src = './assets/hsbc.svg'
                        }}
                        onMouseEnter={(e) => {
                          e.target.src = './assets/hsbc_color.svg'
                        }}
                        src="./assets/hsbc.svg" alt="HSBC" style={{ width: 40 }} />
                    </a>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row >
      </TNContent>
    </Affix>
  )
};


export default AppHeader;